import styled from "styled-components";

export const AuctionReservationWrapper = styled.div`
  .auctionTable {
    min-width: 100%;
  }
  .userName {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .profileIcon {
    width: 16px;
    height: 16px;
    stroke: blue;
    fill: blue;
    margin-left: 5px;
  }
`;
